export default __webpack_public_path__ + "static/media/banner-page-cooperative-banks.9e7cea3f.png";